// extracted by mini-css-extract-plugin
export const container = "Link-module--container--1fRYg";
export const green = "Link-module--green--1JsEn";
export const classArrow = "Link-module--classArrow--2yzAO";
export const outline = "Link-module--outline--2Spec";